import { render } from "./radpk.vue?vue&type=template&id=c11a2924"
import script from "./radpk.vue?vue&type=script&lang=js"
export * from "./radpk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__